/**
 * @desc 根据会员id获取个人认证详情
 */
import { AuditPersonEntity } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryAuditPersonDetailByMemberIdParameter = {
  memberId?: string
}

const method = 'GET'
const url = '/auth/audit/getPersonByMemberId'

export const queryAuditPersonDetailByMemberIdApi = (
  params?: QueryAuditPersonDetailByMemberIdParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AuditPersonEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryAuditPersonDetailByMemberIdApi.method = method
queryAuditPersonDetailByMemberIdApi.url = url
